// Port of SuiteModel/FractionalIndex.swift: base-62 position keys that sort with `<` and never end in "0".
const DIGITS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const BASE = DIGITS.length;
const VALUES = new Map([...DIGITS].map((c, i) => [c, i]));

/** A key strictly between `lower` and `upper` (undefined = open end); just after `lower` if they're equal or reversed. */
export function between(lower?: string, upper?: string): string {
  if (lower !== undefined && upper !== undefined && lower >= upper) return between(lower, lower + DIGITS[1]);
  const a = [...(lower ?? "")].map((c) => VALUES.get(c) ?? 0);
  const b = upper === undefined ? undefined : [...upper].map((c) => VALUES.get(c) ?? 0);
  return midpoint(a, b).map((i) => DIGITS[i]).join("");
}

function midpoint(a: number[], b?: number[]): number[] {
  if (b) {
    let n = 0;
    while (n < b.length && (n < a.length ? a[n] : 0) === b[n]) n++;
    if (n > 0) return [...b.slice(0, n), ...midpoint(a.slice(n), b.slice(n))];
  }
  const digitA = a[0] ?? 0;
  const digitB = b?.[0] ?? BASE;
  if (digitB - digitA > 1) return [Math.floor((digitA + digitB) / 2)];
  if (b && b.length > 1) return [b[0]];
  return [digitA, ...midpoint(a.slice(1), undefined)];
}

/** `count` evenly spread ascending keys. */
export function sequence(count: number): string[] {
  if (count <= 0) return [];
  let width = 1, space = BASE;
  while (space < (count + 1) * 4) { width++; space *= BASE; }
  const step = Math.floor(space / (count + 1));
  return Array.from({ length: count }, (_, i) => {
    let v = (i + 1) * step;
    if (v % BASE === 0) v += 1;
    const chars = new Array<string>(width).fill("0");
    for (let p = width - 1; p >= 0; p--) { chars[p] = DIGITS[v % BASE]; v = Math.floor(v / BASE); }
    return chars.join("");
  });
}
